export default __webpack_public_path__ + "static/media/rewardChart2.74444fc7.svg";